import React, { useState, useEffect } from "react";
import "./HomeSlider.css";
import slide1 from "../Images/JAD2.jpeg";
import slide2 from "../Images/JADConvacation.jpeg";
import slide3 from "../Images/JAD4.jpeg";
import slide4 from "../Images/JADConvacation.jpeg";

const slides = [
  {
    image: slide1,
    title: "Diploma in Architectural Course",
    description: "6 Month Diploma in Architecture is a technical course that teaches the basics of architectural design, drafting, and building construction, preparing students to assist architects and work in the construction and design field.",
  },
  {
    image: slide2,
    title: "Autocade, Revit, Sketchup and Lumion ",
    description: "AutoCAD, Revit, SketchUp, and Lumion are key architecture tools used for drafting, 3D modeling, building design, and creating realistic visualizations.",
  },
  {
    image: slide3,
    title: "Work Offer",
    description: "A job offer is a formal proposal from an employer to a candidate, stating the position, salary, work conditions, and terms of employment.",
  },
  {
    image: slide4,
    title: "Convacation",
    description: "A Convocation is a formal ceremony where students are officially awarded their degrees, diplomas, or certificates by an educational institution. It is a celebration of academic achievement and marks the completion of a course of study.",
  },
];

function HomeSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 3000); // 3 seconds

    return () => clearInterval(interval); // cleanup
  }, []);

  return (
    <div className="home-slider">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === currentIndex ? "active" : ""}`}
        >
          <img src={slide.image} alt={slide.title} className="slide-image" />
          <div className="slide-content">
            <h3>{slide.title}</h3>
            <p>{slide.description}</p>
          </div>
        </div>
      ))}
      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? "active-dot" : ""}`}
            onClick={() => setCurrentIndex(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default HomeSlider;
